import { DisplayComponent } from "~/components/newsletter/newsletter-widget/enums";
export const config = {
  defaultDisplayComponent: DisplayComponent.SignUpNewsletter,
  hasResetAfterSuccess: false,
  hasSanitizeSubscribedNewsletter: false
};